import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricingIncludes, coverImage, checkoutUrl } from '../data/landing';
export function PricingSection() {
  return <section id="oferta" className="scroll-mt-6 bg-cream pb-24 md:pb-32" data-id="element-111" data-mp="1egnp9qg39ks0">
      <div className="mx-auto max-w-5xl px-5 md:px-8" data-id="element-112" data-mp="1ja0eo2sldvlt">
        <div className="grid overflow-hidden rounded-3xl border-2 border-gold-soft bg-white shadow-[0_40px_100px_-40px_rgba(139,100,33,0.45)] md:grid-cols-[0.8fr_1.2fr]" data-id="element-113" data-mp="1nakcz9owj59j">
          <div className="flex items-center justify-center bg-parchment p-8 md:p-10" data-id="element-114" data-mp="1s7slsjo5twy4">
            <img src={coverImage} alt="Portada de El Poder de los Salmos" className="w-full max-w-[260px] rounded-xl shadow-[0_24px_50px_-20px_rgba(43,33,24,0.5)]" data-id="element-115" data-mp="1x99kq9n339c2" />
          </div>
          <div className="p-8 md:p-12" data-id="element-116" data-mp="2vqpx7kfu4ug">
            <p className="text-sm font-black uppercase tracking-[0.18em] text-gold" data-id="element-117" data-mp="2ws5npceffii">Tu pack digital completo</p>
            <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-ink md:text-4xl" data-id="element-118" data-mp="7vmtj5p83u9h">
              El Poder de los Salmos + 3 bonos exclusivos
            </h2>

            <div className="mt-6 flex items-end gap-4" data-id="element-119" data-mp="1hon2pq4ihkuu">
              <span className="pb-2 text-xl text-muted line-through" data-id="element-120" data-mp="1cq3lg30v4x8t">US$39,99</span>
              <span className="font-serif text-6xl font-bold leading-none text-gold-dark md:text-7xl" data-id="element-121" data-mp="17sadb4g01t5w">US$14,99</span>
            </div>
            <p className="mt-2 font-bold text-ink" data-id="element-122" data-mp="25e7t2u2zvke5">Un solo pago · Pagas en la Moneda de tu Pais </p>

            <ul className="mt-7 space-y-3" data-id="element-123" data-mp="20hqzhkd10dto">
              {pricingIncludes.map(item => <li key={item} className="flex items-start gap-3 text-ink/85" data-id="element-124" data-mp="1vgl75nna2sko">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-125" data-mp="1rg1ael6m9qz2">
                    <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-126" data-mp="k2g1mq7f2an8" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <CtaButton href={checkoutUrl} size="lg" className="mt-9 w-full" data-id="element-127" data-mp="hh8bpj090da6">
              Sí, quiero mi pack completo 
            </CtaButton>

            <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-muted" data-id="element-128" data-mp="mgcm2cywsh23">
              <li className="flex items-center gap-1.5" data-id="element-129" data-mp="7j2dpchkbral">
                <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-130" data-mp="ci5doiior7bp" /> Pago seguro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-131" data-mp="3uweb67ibyboj">
                <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-132" data-mp="3uutgmhw0msqo" /> Entrega digital
              </li>
              <li className="flex items-center gap-1.5" data-id="element-133" data-mp="3kyqhlkwgna7y">
                <InfinityIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-134" data-mp="3l0bcxcqlmx6v" /> Acceso para volver a consultar
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}